import React from 'react';
import { FormLabel } from '../FormLabel';
import { FormHelperText } from '../FormHelperText';
import { pickAriaProps, pickComponentCommonProps, } from '../../interfaces/commonProps';
import { useSpacing } from '../../api/spacing/useSpacing';
import { StyledInput, StyledTextField, StyledInputWrapper, StyledExtension, StyledTextFieldLayout, } from './TextField.styles';
import { textFieldPropTypes } from './TextField.types';
const noop = () => { };
export const TextField = React.forwardRef(({ autoComplete, disabled = false, invalid = false, hint, extensionEnd, id, inputId, inputMode, inputRef, label, labelEffect = 'float', list, max, maxLength, min, minLength, name, onBlur = noop, onChange = noop, onFocus = noop, pattern, readOnly = false, required = false, type = 'text', validationMessage, value, ...restProps }, ref) => {
    const hasStringExtension = typeof extensionEnd === 'string';
    const extensionEndId = `${inputId}__extension-end`;
    const hintMessageId = `${inputId}__hint-message`;
    const validationMessageId = `${inputId}__invalid-message`;
    const ariaProps = pickAriaProps(restProps);
    const describedBy = [
        hasStringExtension ? extensionEndId : '',
        hint ? hintMessageId : '',
        invalid ? validationMessageId : '',
        ariaProps['aria-describedby'] || '',
    ]
        .join(' ')
        .trim() || undefined;
    const extensionProps = {
        disabled,
        invalid,
        readOnly,
    };
    const extension = typeof extensionEnd === 'string' ? (React.createElement(StyledExtension, { id: extensionEndId, ...extensionProps }, extensionEnd)) : (extensionEnd &&
        React.cloneElement(React.Children.only(extensionEnd), extensionProps));
    return (React.createElement(StyledTextField, { id: id, outerSpacing: useSpacing(restProps), ref: ref, ...pickComponentCommonProps(restProps) },
        React.createElement(StyledTextFieldLayout, { hasExtensionEnd: Boolean(extensionEnd) },
            React.createElement(StyledInputWrapper, { disabled: disabled, invalid: invalid, readOnly: readOnly },
                React.createElement(FormLabel, { as: "label", disabled: disabled, effect: labelEffect, empty: !value, invalid: invalid, htmlFor: inputId, required: required }, label),
                React.createElement(StyledInput, { ...ariaProps, autoComplete: autoComplete, "aria-describedby": describedBy, disabled: disabled, id: inputId, inputMode: inputMode, list: list, max: max, maxLength: maxLength, min: min, minLength: minLength, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, pattern: pattern, readOnly: readOnly, ref: inputRef, required: required, type: type, value: value })),
            extension),
        hint && (React.createElement(FormHelperText, { id: hintMessageId, spaceStackStart: 's', variant: "hint" }, hint)),
        invalid && validationMessage && (React.createElement(FormHelperText, { id: validationMessageId, spaceStackStart: hint ? 'xxs' : 's', variant: "invalid" }, validationMessage))));
});
TextField.propTypes = textFieldPropTypes;
TextField.displayName = 'TextField';
//# sourceMappingURL=TextField.js.map